<template>
  <a-row :gutter="24">
    <a-col :md="10" :sm="24">
      <a-card :bordered="false">
        <div class="table-operator">
          <a-button type="primary" icon="plus" @click="handleInsert"
            >添加部门</a-button
          >
          <a-button type="primary" icon="import">导入</a-button>
          <a-button type="primary" icon="export">导出</a-button>
          <a-button type="default" icon="delete" @click="handleDel"
            >删除</a-button
          >
        </div>
        <a-alert type="info" :showIcon="true">
          <div slot="message">
            当前选择：<span>{{ tempSelected.title || "无" }}</span>
            <a
              v-if="tempSelected"
              style="margin-left:8px"
              @click="onClearSelected"
              >取消选择</a
            >
          </div>
        </a-alert>
        <a-input-search
          style="margin:16px 0"
          placeholder="搜索"
          @change="deptSearch"
        ></a-input-search>
        <a-tree
          :expandedKeys="expandedKeys"
          :selectedKeys="selectedKeys"
          :autoExpandParent="autoExpandParent"
          :treeData="treeData"
          @expand="onExpand"
          @select="onSelect"
        >
          <template slot="title" slot-scope="{ title }">
            <span v-if="title.indexOf(searchValue) > -1">
              {{ title.substr(0, title.indexOf(searchValue)) }}
              <span style="color: #f50">{{ searchValue }}</span>
              {{
                title.substr(title.indexOf(searchValue) + searchValue.length)
              }}
            </span>
            <span v-else>{{ title }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-col>
    <a-col :md="14" :sm="24">
      <a-card :bordered="false">
        <a-tabs>
          <a-tab-pane key="1" tab="基本信息">
            <a-card bordered v-if="selectedKeys.length > 0">
              <a-form :form="form">
                <a-form-item
                  label="机构名称"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                >
                  <a-input
                    v-decorator="[
                      'deptName',
                      { rules: [{ required: true, message: '请填写机构名称' }] }
                    ]"
                    placeholder="请填写机构名称"
                  ></a-input>
                </a-form-item>
                <a-form-item
                  label="上级部门"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                >
                  <a-tree-select
                    v-decorator="['parentId']"
                    :replaceFields="{
                      title: 'title',
                      key: 'key',
                      value: 'key',
                      children: 'children'
                    }"
                    showSearch
                    style="width:100%"
                    :treeData="treeData"
                    disabled
                  >
                  </a-tree-select>
                </a-form-item>
                <a-form-item
                  label="机构编码"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                >
                  <a-input
                    v-decorator="[
                      'deptCode',
                      { rules: [{ required: true, message: '请填写机构编码' }] }
                    ]"
                    placeholder="请填写机构编码"
                    disabled
                  ></a-input>
                </a-form-item>
                <div class="anty-form-btn">
                  <a-button
                    @click="emptyCurrForm"
                    type="default"
                    htmlType="button"
                    icon="close"
                    >取消</a-button
                  >
                  <a-button
                    @click="submitCurrForm"
                    type="primary"
                    htmlType="button"
                    icon="form"
                    :loading="loading"
                    >保存</a-button
                  >
                </div>
              </a-form>
            </a-card>
            <a-card v-else>
              <a-empty>
                <span slot="description"> 请先选择一个部门! </span>
              </a-empty>
            </a-card>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-col>
    <DeptListModal ref="deptModal" @ok="modalSuccess" />
  </a-row>
</template>

<script>
import DeptListModal from "./modules/DeptListModal";
import { findAllDepts, save, update } from "@/api/system/dept";
import { notification } from "ant-design-vue";
import pick from "lodash.pick";

// import JImageUpload from "@components/JImageUpload/JImageUpload";

export default {
  components: {
    DeptListModal
  },
  data() {
    return {
      // deptTree
      expandedKeys: [],
      selectedKeys: [],
      tempSelected: {},
      searchValue: "",
      autoExpandParent: true,
      treeData: [],
      tempDeptTree: [],
      dataList: [],
      // form
      form: this.$form.createForm(this),
      loading: false,
      labelCol: { lg: { span: 5 }, sm: { span: 24 } },
      wrapperCol: { lg: { span: 15 }, sm: { span: 24 } },
      name: "",
      parentId: "",
      fileList: [] //logo
    };
  },
  created() {
    this.initTree();
  },
  methods: {
    initTree() {
      findAllDepts().then(res => {
        if (res.resultCode === 1) {
          this.generateData(res.result);
        }
      });
    },
    generateData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].scopedSlots = { title: "title" };
        if (data[i].children) {
          this.generateData(data[i].children);
        }
      }
      this.treeData = data;
      this.generateList(this.treeData);
    },
    generateList(data) {
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const key = node.key;
        const title = node.title;
        this.dataList.push({ key, title: title });
        if (node.children) {
          this.generateList(node.children);
        }
      }
    },
    getParentKey(key, tree) {
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key;
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSelect(key, e) {
      let record = e.node.dataRef;
      record.deptName = record.title;
      record.id = record.key;
      // tree选择的keys
      this.selectedKeys = [record.key];
      // alert显示的node
      this.tempSelected = Object.assign({}, record);
      // form更新
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(record, "deptName", "deptCode", "parentId")
        );
      });
    },
    onClearSelected() {
      this.tempSelected = {};
      this.selectedKeys = [];
      this.parentId = "";
    },
    deptSearch(e) {
      const value = e.target.value;
      const expandedKeys = this.dataList
        .map(item => {
          if (item.title.indexOf(value) > -1) {
            return this.getParentKey(item.key, this.treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    },
    emptyCurrForm() {
      this.onClearSelected();
      // this.form.resetFields();
    },
    submitCurrForm() {
      this.loading = true;
      this.form.validateFields((err, values) => {
        if (!err) {
          if (!this.tempSelected.id) {
            console.log(this.tempSelected);
            this.$message.warning("请点击选择要修改部门!");
            this.loading = false;
            return;
          }
          let formData = Object.assign(this.tempSelected, values);
          console.log("Received values of form: ", formData);
          save({ ...formData })
            .then(res => {
              if (res.resultCode === 1) {
                this.onClearSelected();
                this.initTree();
              }
              notification.success({
                message: res.message
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleInsert() {
      this.$refs.deptModal.openDrawer();
    },
    modalSuccess(msg) {
      this.$notification.success({
        message: msg
      });
      this.onClearSelected();
      this.initTree();
    },
    handleDel() {
      let that = this;
      if (this.tempSelected && this.tempSelected.id) {
        let params = { deptIdStrs: this.tempSelected.id, status: "D" };
        this.$confirm({
          title: "提示",
          content: "确认删除该部门吗?",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            update({ ...params }).then(res => {
              that.onClearSelected();
              that.initTree();
              that.$notification.info({
                message: res.message
              });
            });
          }
        });
      } else {
        this.$message.warning("请先选择一个部门!");
      }
    }
  }
};
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.anty-form-btn {
  width: 100%;
  text-align: center;
}

.anty-form-btn button {
  margin: 0 5px;
}
</style>
